export enum VideoState {
  unstarted,
  ended,
  playing,
  paused,
}
